/**
 * Phase 6e2c-0 — NOTES POPUP (§30.7).
 *
 * React port of component_selector.notes.popup.js (+tmpl, 56+14). A generic
 * `{notes:[{note}]}` list popup (#fan_select_notes_popup.popup-wrapper.width-small,
 * heading "Notes", .close_notes). Chassis-level so fan/coil can reuse it later
 * (they show it on the show_notes action / after a coil rate). special_options
 * does not use it, but it is part of the chassis contract so it is built now.
 *
 * Markup/classes match the legacy tmpl so the existing AHU-board CSS applies.
 */

interface NotesPopupProps {
  notes: Array<{ note: string }>;
  open: boolean;
  onClose: () => void;
}

export const NotesPopup = ({ notes, open, onClose }: NotesPopupProps) => (
  <div
    id="fan_select_notes_popup"
    className={`popup-wrapper width-small${open ? ' active' : ''}`}
  >
    <div className="popup-content">
      <h2 className="popup-heading">Notes</h2>
      <div>
        <div className="clearfix row popup-content-part">
          {notes.map((n, i) => (
            <p key={i}>{n.note}</p>
          ))}
        </div>
        <div className="popup-control-buttons">
          <button className="close_notes" name="close_notes" onClick={onClose}>
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
);
